import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.scss';
import { ConnectedApp } from './pages';
import { Provider } from 'react-redux';
import * as serviceWorker from './helper/serviceWorker';
import { store } from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedApp/>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
